import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useGaEventData = () => useSelector(store, (state) => state.context.gaEventData);
